import { ApiError } from "@/lib/apiClient";

/** Backend error code: objective/KR reads are restricted to leaders. */
export const OKR_LEADER_ONLY = "OKR_LEADER_ONLY";

/** Backend error code: objective/KR writes are restricted to directors and above. */
export const OKR_DIRECTOR_ONLY = "OKR_DIRECTOR_ONLY";

const okrErrorCode = (error: unknown) =>
  error instanceof ApiError ? (error.body as { message?: string })?.message : undefined;

/** True when the reads on this page were refused because the viewer is not a leader. */
export const isOkrLeaderOnly = (error: unknown) => okrErrorCode(error) === OKR_LEADER_ONLY;

/**
 * Toast copy for an OKR mutation failure: names the director gate when the backend refused on it,
 * else the caller's own wording — a 403 says nothing about what went wrong otherwise.
 */
export const okrErrorDescription = (error: unknown, fallback: string) =>
  okrErrorCode(error) === OKR_DIRECTOR_ONLY ? "Only directors and above can change OKRs." : fallback;
